// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const mule = defineModel({
  id: "mule",
  scale: 2.54, // real-world size correction (see Model.scale)
  batchId: "future",
  name: "Mule",
  tags: ["creature","mule","low-poly","age-of-mcp","future"],
  summary: "A mule — a tough, surefooted pack and haul animal.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.11,
  fits: ["draft"],
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.0095, 0.008, 0.085, 5), color: "#7a6a55", position: [0.055, 0.045, 0.032] },
      { geometry: new THREE.CylinderGeometry(0.011, 0.011, 0.012, 5), color: "#3c332a", position: [0.055, 0.006, 0.032] },
      { geometry: new THREE.CylinderGeometry(0.0095, 0.008, 0.085, 5), color: "#7a6a55", position: [0.055, 0.045, -0.032] },
      { geometry: new THREE.CylinderGeometry(0.011, 0.011, 0.012, 5), color: "#3c332a", position: [0.055, 0.006, -0.032] },
      { geometry: new THREE.CylinderGeometry(0.0095, 0.008, 0.085, 5), color: "#7a6a55", position: [-0.055, 0.045, 0.032] },
      { geometry: new THREE.CylinderGeometry(0.011, 0.011, 0.012, 5), color: "#3c332a", position: [-0.055, 0.006, 0.032] },
      { geometry: new THREE.CylinderGeometry(0.0095, 0.008, 0.085, 5), color: "#7a6a55", position: [-0.055, 0.045, -0.032] },
      { geometry: new THREE.CylinderGeometry(0.011, 0.011, 0.012, 5), color: "#3c332a", position: [-0.055, 0.006, -0.032] },
      { geometry: new THREE.IcosahedronGeometry(0.055, 0), color: "#7a6a55", position: [0, 0.115, 0], scale: [1.7, 1, 0.85] },
      { geometry: new THREE.CylinderGeometry(0.018, 0.024, 0.06, 6), color: "#8a7a63", position: [0.078, 0.14, 0], rotation: [0, 0, -0.7] },
      { geometry: new THREE.BoxGeometry(0.062, 0.03, 0.028), color: "#8a7a63", position: [0.118, 0.158, 0], rotation: [0, 0, -0.2] },
      { geometry: new THREE.BoxGeometry(0.02, 0.022, 0.024), color: "#5c5042", position: [0.148, 0.146, 0] },
      { geometry: new THREE.ConeGeometry(0.011, 0.052, 4), color: "#7a6a55", position: [0.098, 0.198, 0.014], rotation: [0.2, 0, 0.12] },
      { geometry: new THREE.ConeGeometry(0.011, 0.052, 4), color: "#7a6a55", position: [0.098, 0.198, -0.014], rotation: [-0.2, 0, 0.12] },
      { geometry: new THREE.BoxGeometry(0.05, 0.018, 0.01), color: "#4a3f31", position: [0.055, 0.165, 0], rotation: [0, 0, -0.5] },
      { geometry: new THREE.IcosahedronGeometry(0.0035, 0), color: "#181410", position: [0.128, 0.165, 0.016] },
      { geometry: new THREE.IcosahedronGeometry(0.0035, 0), color: "#181410", position: [0.128, 0.165, -0.016] },
      { geometry: new THREE.CylinderGeometry(0.005, 0.004, 0.055, 4), color: "#7a6a55", position: [-0.088, 0.1, 0], rotation: [0, 0, 0.9] },
      { geometry: new THREE.IcosahedronGeometry(0.012, 0), color: "#4a3f31", position: [-0.114, 0.075, 0], scale: [0.8, 1.2, 0.8] },
    ],
  animations: [],
});
